import React, { useState, useRef, useEffect } from "react";
import * as XLSX from "xlsx";
import { FileDown, FileSpreadsheet } from "lucide-react";

const ExportDropdown = ({ data }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef();

  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleExportCSV = () => {
    const csvRows = [];
    const headers = Object.keys(data[0]);
    csvRows.push(headers.join(","));

    for (const row of data) {
      const values = headers.map(
        (header) => `"${String(row[header]).replace(/"/g, '""')}"`
      );
      csvRows.push(values.join(","));
    }

    const csvString = csvRows.join("\n");
    const blob = new Blob([csvString], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = "export.csv";
    a.click();
    window.URL.revokeObjectURL(url);
  };

  const handleExportExcel = () => {
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, "export.xlsx");
  };

  return (
    <div className="relative md:hidden lg:block inline-block" ref={ref}>
      <button
        onClick={() => setOpen(!open)}
        className="px-4 py-2 rounded-lg font-semibold transition-colors duration-200 bg-gray-100 text-gray-700 hover:bg-gray-200 text-sm flex items-center"
      >
        <FileDown className="w-4 h-4 mr-2" />
        Export
      </button>
      {open && (
        <div className="absolute left-0 mt-2 w-52 bg-white border border-gray-200 rounded-lg shadow-lg z-50">
          <button
            onClick={() => {
              setOpen(false);
              handleExportExcel();
            }}
            className="flex items-center w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-50 transition-colors"
          >
            <FileSpreadsheet className="w-4 h-4 mr-2 text-gray-600" />
            Export as Excel
          </button>
          <button
            onClick={() => {
              setOpen(false);
              handleExportCSV();
            }}
            className="flex items-center w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-50 rounded-b-lg transition-colors"
          >
            <FileDown className="w-4 h-4 mr-2 text-gray-600" />
            Export as CSV
          </button>
        </div>
      )}
    </div>
  );
};

export default ExportDropdown;
